import React from 'react';
import AppliedFilters from '../facets/applied-filters';
import Facets from '../facets';

export default (props) => {
  return (
      <div className="col-md-3 hidden-xs hidden-sm hidden-md">
        <AppliedFilters {...props}/>
        <Facets {...props} />
      </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/recalls-list/side-bar/sidebar.js